const APP_VERSION = '0.0.1'
const IS_DEV = import.meta.env.DEV

const API_URL = import.meta.env.VITE_API_URL
const GRAPHQL_URL = import.meta.env.VITE_GRAPHQL_URI

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID

const MAX_SCORE_MID_EXAM = 180

const POSTHOG_PROXY = 'https://ingest.yes.co.id'
const POSTHOG_API_KEY = 'phc_TFDqRiqDtOk4Pi7EGEPFKMUtP8TpwUEURFm3GybUp9h'

export {
  APP_VERSION,
  IS_DEV,
  GRAPHQL_URL,
  API_URL,
  GOOGLE_CLIENT_ID,
  MAX_SCORE_MID_EXAM,
  POSTHOG_PROXY,
  POSTHOG_API_KEY,
}
